import React, { Component } from "react";
import "./index.scss";
import { GenerateAtribute } from "../../@utils/generate-atribute";

export class OddoMetter extends Component {
  constructor(props) {
    super(props);
  }
  elRef = React.createRef(null);
  elArray = {};
  static defaultProps = {};

  componentDidMount = () => {
    if (this.elRef) {
      setTimeout(() => {
        this.createOdoMetter(this.getValue(), this.elRef);
      }, 2000);
    }
  };

  getValue = () => this.calculate(this.props.media["fox-value"] || 99);

  calculate = (val = 0) => {
    if (val <= 9) {
      return `0${val}`;
    }
    return val;
  };

  getContainerHeight = (arr = []) => arr[0] * (arr.length - 1);

  getContentPos = (heights = [], target = 0, index = 0) => {
    const reversed = index % 2 !== 0;
    const values = reversed ? [...this._arr].reverse() : this._arr;

    let total = 0;

    for (const value of values) {
      if (value === target) {
        break;
      }

      total += heights[value] ?? 0;
    }

    return -total;
  };

  _elHeighs = [];
  _arr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  createOdoMetter = (value, elTarget) => {
    const el = elTarget;
    el.innerHTML = "";
    const valArr = value?.toString()?.split("");
    // const arrReversed = arr.reverse();
    valArr.forEach(async (item, i) => {
      const elHeights = [];
      const counterWrapper = document.createElement("div");
      counterWrapper.style["overflow"] = "hidden";
      counterWrapper.style["minHeight"] = "90px";
      counterWrapper.className = "odo_wrapper";
      const slider = document.createElement("div");
      slider.classList.add("slider");
      slider.classList.add(`number_${i}`);
      el.append(counterWrapper);
      counterWrapper.append(slider);

      const arrVal = i % 2 !== 0 ? [...this._arr].reverse() : [...this._arr];
      await arrVal.forEach((targetVal) => {
        const createEll = (numbering) => {
          const itemCounter = document.createElement("div");
          itemCounter.style["minHeight"] = "90px";
          itemCounter.className = "element_odo";
          itemCounter.innerHTML = targetVal;
          slider.append(itemCounter);
          elHeights.push(itemCounter?.getBoundingClientRect?.()?.height);
        };
        createEll(targetVal);
      });

      const marginPos = i % 2 !== 0 ? -1 : 0;
      const yPos = this.getContainerHeight(elHeights);
      slider.setAttribute("item-height", yPos);
      slider.style.transform = `translateY(${yPos * marginPos}px)`;
      this._elHeighs.push(elHeights);
      this.elArray[i] = slider;
      counterWrapper.style["height"] = `${elHeights[0]}px`;
    });

    this.animatedScroll();
  };

  getElementConfig = (props) => {
    const res = GenerateAtribute(props);
    return res;
  };

  startAnimated = () => {
    const valArr = this.getValue()?.toString()?.split("");
    valArr.forEach((val, i) => {
      const targetY = this.getContentPos(this._elHeighs[i], parseInt(val), i);
      this.elArray[i].style.transform = `translateY(${targetY}px)`;
    });
  };

  _timer = null;
  animatedScroll = () => {
    window.document.body.addEventListener("scroll", (e) => {
      const triggerButton = (window.innerHeight / 5) * 4;
      // const targetAnimated = document.querySelectorAll('.animated');
      if (this.elRef?.getBoundingClientRect?.()?.top < triggerButton) {
        clearTimeout(this._timer);
        setTimeout(this.startAnimated);
      } else {
        // clearTimeout(this._timer);
        // setTimeout( this.startAnimatedBack)
        // this.startAnimated()
      }
    });
  };

  render() {
    const { props } = this;
    return (
      <section className={`oddo-metter-parent ${props.className}`} {...this.getElementConfig(props)}>
        <section className={"oddo-metter"} ref={(ref) => (this.elRef = ref)}></section>
      </section>
    );
  }
}
